module.exports = __webpack_public_path__ + "img/cloud-45-frames.4e27bbcc.png";